import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { userReducer } from './Reducer/userReducer';
import productReducer from './Reducer/productReducer';
import auditHistoryReducer from './Reducer/auditHistorySlice';
import exhibitorProductReducer from './Reducer/exhibitorProductSlice'; // Ensure correct path
import keyExhibitorsSlice from './Reducer/keyExhibitorSlice.js';
import seoSlice from './Reducer/seoSlice.js';
import productVariationReducer from './Reducer/productVariationSlice';
import dataCountReducer from './Reducer/dataCountSlice';
import sampleUsersReducer from './Reducer/sampleUsersSlice';
import registerUserReducer from './Reducer/adminSlice.js';
import dataAdminSlice from './Reducer/dataAdminSlice.js';
import categoriesSlice from './Reducer/categoriesSlice.js'; // Ensure correct path
import redirectionReducer from './Reducer/redirectionSlice.js'; // Ensure correct path
import subscriptionPlanReducer from './Reducer/Subscription/subscriptionPlanSlice';
import orderListReducer from './Reducer/Order/orderListslice.js'; // Ensure correct path
import productBatchesReducer from './Reducer/productBatchesSlice.js'; // Add product batches slice

// Combine all reducers without persist
const rootReducer = combineReducers({
  user: userReducer, // Directly use the userReducer
  products: productReducer,
  auditHistory: auditHistoryReducer,
  exhibitorProducts: exhibitorProductReducer, // Corrected typo here
  keyExhibitor:keyExhibitorsSlice,
  seo: seoSlice,
  productVariations: productVariationReducer,
  dataCount:dataCountReducer,
  sampleUsers: sampleUsersReducer,
  registerUser: registerUserReducer,
  dataAdmin: dataAdminSlice, // Add the dataAdmin slice
  categories: categoriesSlice, // Add the categories slice
  redirection: redirectionReducer,
  subscriptionPlan: subscriptionPlanReducer,
  orderList: orderListReducer, // Add the orderList slice
  productBatches: productBatchesReducer, // Add product batches slice
});

// Configure the store without persistReducer
const store = configureStore({
  reducer: rootReducer, // Use rootReducer directly
});

export default store ;
